export const LogoMark = ({ className = "h-9 w-9", dark = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill={dark ? "#FAF9F6" : "#111827"} />
    <path d="M44.5 21.5A15 15 0 1 0 44.5 42.5" fill="none" stroke={dark ? "#111827" : "#FAF9F6"} strokeWidth="7" strokeLinecap="round" />
    <circle cx="47" cy="32" r="5" fill="#E63946" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="group inline-flex items-center gap-2.5">
    <span className="transition-transform duration-500 group-hover:rotate-[-12deg]">
      <LogoMark dark={dark} />
    </span>
    <span className={`font-display text-xl font-bold tracking-tight ${dark ? "text-canvas" : "text-ink"}`}>
      the catalyst<span className="text-flame">.</span>
    </span>
  </span>
);
